module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/034-efae952c39152b9b4b628ac3383181e7.jpg";